import React from 'react';

import { type PatientImportJobStatus } from '@eluve/api-contract';

import { useImportJob } from '../hooks/useImportJob';

import { PatientImportDoneScreen } from './PatientImportDoneScreen';
import { PatientImportHeaderMismatchScreen } from './PatientImportHeaderMismatchScreen';
import { PatientImportProgressScreen } from './PatientImportProgressScreen';
import { PatientImportReviewScreen } from './PatientImportReviewScreen';

const SCREEN_FOR_STATUS: Record<
  PatientImportJobStatus,
  React.FC<{ jobId: string; tenantId: string }>
> = {
  PARSING: (props) => (
    <PatientImportProgressScreen phase="parsing" {...props} />
  ),
  VALIDATING: (props) => (
    <PatientImportProgressScreen phase="parsing" {...props} />
  ),
  COMMITTING: (props) => (
    <PatientImportProgressScreen phase="committing" {...props} />
  ),
  HEADER_MISMATCH: PatientImportHeaderMismatchScreen,
  REVIEW_READY: PatientImportReviewScreen,
  COMPLETED: (props) => (
    <PatientImportDoneScreen variant="default" {...props} />
  ),
  PARTIALLY_COMPLETED: (props) => (
    <PatientImportDoneScreen variant="partial" {...props} />
  ),
  CANCELLED: (props) => (
    <PatientImportDoneScreen variant="cancelled" {...props} />
  ),
  FAILED: (props) => <PatientImportDoneScreen variant="failed" {...props} />,
};

export const PatientImportStatusRouter: React.FC<{
  jobId: string;
  tenantId: string;
}> = ({ jobId, tenantId }) => {
  const job = useImportJob(tenantId, jobId);
  const Screen = SCREEN_FOR_STATUS[job.status];
  return <Screen jobId={jobId} tenantId={tenantId} />;
};
